<template>
  <BlocoFormularioCadastro voltar="/usuario" @salvar="submit()">
    <template #form>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="panel panel-primary">
            <div class="panel-heading">Usuário</div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div
                    :class="{ 'has-error': v$.usuario.name.$error }"
                    data-test-id="nome"
                    class="form-group"
                  >
                    <label for="nome"> Nome <sup>(1)</sup> </label>
                    <input
                      id="nome"
                      v-model.trim="usuario.name"
                      data-test-id="input-nome"
                      type="text"
                      class="form-control"
                      name="nome"
                      placeholder="Nome"
                      @input="v$.usuario.name.$touch()"
                    />
                    <span v-if="v$.usuario.name.$dirty">
                      <span v-if="!v$.usuario.name.required" class="help-block">
                        Campo é obrigatório.
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  :class="{ 'has-error': v$.usuario.email.$error }"
                  data-test-id="email"
                  class="form-group col-xs-12 col-sm-6 col-md-6 col-lg-6"
                >
                  <label for="email"> E-mail <sup>(1)</sup> </label>
                  <input
                    id="email"
                    v-model.trim="usuario.email"
                    data-test-id="input-email"
                    type="email"
                    class="form-control"
                    name="email"
                    placeholder="E-mail"
                    @input="v$.usuario.email.$touch()"
                  />
                  <span v-if="v$.usuario.email.$dirty">
                    <span v-if="!v$.usuario.email.required" class="help-block">
                      Campo é obrigatório.
                    </span>
                  </span>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                  <div
                    :class="{ 'has-error': v$.usuario.perfil.$error }"
                    data-test-id="perfil"
                    class="form-group"
                  >
                    <label for="perfil"> Perfil <sup>(1)</sup> </label>
                    <select
                      id="perfil"
                      v-model="usuario.perfil"
                      data-test-id="select-perfil"
                      name="perfil"
                      class="form-control"
                    >
                      <option value="" selected disabled>
                        Selecione o perfil
                      </option>
                      <option
                        v-for="perfil in perfis"
                        :key="perfil._id"
                        :value="perfil.descricao"
                      >
                        {{ perfil.descricao }}
                      </option>
                    </select>
                    <span v-if="v$.usuario.perfil.$dirty">
                      <span
                        v-if="!v$.usuario.perfil.required"
                        class="help-block"
                      >
                        Campo é obrigatório.
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  :class="{ 'has-error': v$.usuario.password.$error }"
                  data-test-id="password"
                  class="form-group col-xs-12 col-sm-6 col-md-6 col-lg-6"
                >
                  <label for="password"> Senha <sup>(1)</sup> </label>
                  <input
                    id="password"
                    v-model="usuario.password"
                    data-test-id="input-password"
                    :disabled="usuario._id"
                    type="password"
                    class="form-control"
                    name="password"
                    placeholder="Senha do usuário"
                    @input="v$.usuario.password.$touch()"
                  />
                  <span v-if="v$.usuario.password.$dirty">
                    <span
                      v-if="!v$.usuario.password.required"
                      class="help-block"
                    >
                      Campo é obrigatório.
                    </span>
                  </span>
                </div>
                <div
                  :class="{
                    'has-error': v$.usuario.passwordConfirmacao.$error,
                  }"
                  data-test-id="passwordConfirmacao"
                  class="form-group col-xs-12 col-sm-6 col-md-6 col-lg-6"
                >
                  <label for="passwordConfirmacao">
                    Repita a senha <sup>(1) (2)</sup>
                  </label>
                  <input
                    id="passwordConfirmacao"
                    v-model="usuario.passwordConfirmacao"
                    data-test-id="input-passwordconfirmacao"
                    :disabled="usuario._id"
                    type="password"
                    class="form-control"
                    name="passwordConfirmacao"
                    placeholder="Repita a senha"
                    @input="v$.usuario.passwordConfirmacao.$touch()"
                  />
                  <span v-if="v$.usuario.passwordConfirmacao.$dirty">
                    <span
                      v-if="!v$.usuario.passwordConfirmacao.required"
                      class="help-block"
                    >
                      Campo é obrigatório.
                    </span>
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-xs-12 col-sm-6 col-md-6 col-lg-6">
                  <label for="unidade"> Unidade </label>
                  <select
                    id="unidade"
                    v-model="usuario.unidades"
                    data-test-id="select-unidade"
                    name="unidade"
                    class="form-control"
                    multiple
                  >
                    <option
                      v-for="unidade in unidades"
                      :key="unidade._id"
                      :value="unidade.nome"
                    >
                      {{ unidade.nome }}
                    </option>
                  </select>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Situação</label>
                    <select
                      id="ativo"
                      v-model="usuario.ativo"
                      data-test-id="select-ativo"
                      name="ativo"
                      class="form-control"
                    >
                      <option :value="true">Ativo</option>
                      <option :value="false">Cancelado</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <p>(1) Campos obrigatórios.</p>
          <p>(2) As senhas devem conferir..</p>
        </div>
      </div>
    </template>
  </BlocoFormularioCadastro>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import {
  email,
  maxLength,
  minLength,
  required,
  requiredIf,
} from '@vuelidate/validators'

import BlocoFormularioCadastro from '@/componentes/formulario/BlocoFormularioCadastro'
import { useMenu } from '@/composables/useMenu'
import PERFIL from '@/constantes/controle_acesso/PERFIL'
import router from '@/router'
import MensagemServico from '@/servicos/MensagemServico'
import UnidadeServico from '@/servicos/UnidadeServico'
import UsuarioServico from '@/servicos/UsuarioServico'

const unidadeServico = new UnidadeServico()
const usuarioServico = new UsuarioServico()
const mensagemServico = new MensagemServico()

export default {
  components: { BlocoFormularioCadastro },

  setup() {
    useMenu(3)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      usuario: {
        name: '',
        email: '',
        password: '',
        passwordConfirmacao: '',
        unidades: [],
        perfil: '',
        ativo: true,
      },
      unidades: [],
      perfis: PERFIL.valores,
    }
  },
  created() {
    unidadeServico.recuperarTodos().then((result) => {
      this.unidades = result.unidades
    })
    this.recuperarUsuario()
  },
  methods: {
    submit() {
      if (this.v$.usuario.$invalid) {
        this.v$.$touch()
        mensagemServico.cadastroInvalido(this.v$)
      } else {
        if (this.usuario._id) {
          usuarioServico
            .atualizar(this.usuario._id, this.usuario)
            .then((res) => {
              if (!res.erro) {
                router.replace({ name: 'Usuarios' })
              }
            })
        } else {
          usuarioServico.criar(this.usuario).then((res) => {
            if (!res.erro) {
              router.replace({ name: 'Usuarios' })
            }
          })
        }
      }
    },
    recuperarUsuario() {
      const id = this.$route.params.id

      if (id) {
        usuarioServico.recuperar(id).then((result) => {
          this.usuario._id = id
          this.usuario.name = result.usuario.name
          this.usuario.email = result.usuario.email
          this.usuario.unidades = result.usuario.unidades
          this.usuario.ativo = result.usuario.ativo
          this.usuario.perfil = result.usuario.perfil
        })
      }
    },
  },
  validations: {
    usuario: {
      name: { required, minLength: minLength(10), maxLength: maxLength(60) },
      email: { required, email },
      password: {
        required: requiredIf(function () {
          return !this.usuario._id
        }),
      },
      passwordConfirmacao: {
        required: requiredIf(function () {
          return !this.usuario._id
        }),
        sameAsPassword(value) {
          return value === this.usuario.password
        },
      },
      perfil: { required },
    },
  },
}
</script>
